/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import Filters from "../../../components/Filters";
import TaxInvoiceDetail from "./TaxInvoiceDetail";
import { ControlTable } from "../../../components/Table";
import { deleteMappingTaxInvoiceClient, getTaxInvoiceList } from "../../../apis/invoices";
import { getParams } from "../../../utils/params";
import { autoHyphen } from "../../../utils/replace";
import useForm from "../../../hooks/useForm";
import { dateToFormat, getDay } from "../../../utils/date";
import { useHistory } from "react-router-dom";
import { remove, cloneDeep, isEmpty, findIndex, get } from "lodash";
import TaxInvoiceClientMapping from "./TaxInvoiceClientMapping";
import IconButton from "../../../components/Button/IconButton";
import DeleteIcon from "../../../assets/images/icon/delete-icon-01.svg";
import systemAlert from "../../../utils/systemAlert";
import TaxInvoiceToTradeInvoice from "./TaxInvoiceToTradeInvoice";
import Icon from "../../../components/Icon";
import CommentIcon from "../../../assets/images/icon/comment-icon.svg";
import { forEach } from "lodash";
import { transformComma } from "../../../utils/validator/comma";
import ToolTip from "../../../components/ToolTip/ToolTip";
import { clientPreview } from "../../../utils/client";
import { preventEvent } from "../../../utils/element";
import { getFinanacesScrapingHistoryList, getFinancesAccounts, scrapingFinanaces } from "../../../apis/finances/auth";
import { viewLoading } from "../../../utils/loading";

const TaxInvoicePurchase = ({
  detailOpen,
  setDetailOpen,
  permission,
  scrapingPermission,
  excelDown = () => { }
}) => {
  const history = useHistory();
  const [sortFields, setSortFields] = useState([
    { key: 'writeDate', order: 'desc' },
    { key: 'issueDate', order: '' },
    { key: 'supBizNo', order: '' },
    { key: 'supCorpName', order: '' },
    { key: 'supRepName', order: '' },
    { key: 'itemName', order: '' },
    { key: 'itemSupAmt', order: '' },
    { key: 'itemTaxAmt', order: '' },
    { key: 'totalAmt', order: '' },
  ]);
  const [fields, setFields] = useState([]);
  const [taxInvoiceType, setTaxInvoiceType] = useState("all");
  const [invoiceRegged, setInvoiceRegged] = useState(true);
  const [rowData, setRowData] = useState({});
  const [checkedList, setCheckList] = useState([]);
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  // 거래처 매핑
  const [isClientMappingOpen, setIsClientMappingOpen] = useState(false);
  const [clientMappingData, setClientMappingData] = useState(null);

  const [reload, setReload] = useState(false);
  const [isScraping, setIsScraping] = useState(false);
  const [timerValue, setTimerValue] = useState(0);

  const timerId = useRef(null);

  // 스크래핑
  const [financeScrapings, setFinanceScrapings] = useState([]);
  const [isScrapingReload, setIsScrapingReload] = useState(false);


  useEffect(() => {
    if (!isEmpty(scrapingPermission) && scrapingPermission.level > 1) {
      getFinancesAccounts("hometax").then(res => {
        setFinanceScrapings(get(res, 'data.accounts[0].financeScrapings', []));
      });
    }
  }, [scrapingPermission]);

  useEffect(() => {
    timerId.current = setInterval(() => {
      setTimerValue(1);
    }, 1000 * 5);
    return () => clearInterval(timerId.current);
  }, []);

  useEffect(() => {
    if (timerValue === 1 && !isEmpty(scrapingPermission) && scrapingPermission.level > 1) {
      setTimerValue(0);

      if (reload && !isEmpty(financeScrapings)) {
        getHistories(financeScrapings[0]);
      }
    }
  }, [timerValue]);

  const getHistories = (financeScraping) => {
    getFinanacesScrapingHistoryList(financeScraping.idx, { search: { state: 9 } })
      .then(res => {
        if (!isEmpty(res.data.histories)) {
          setReload(true);
          setIsScraping(true);
          setIsScrapingReload(true);
        } else {
          setReload(false);
          setIsScraping(false);
          isScrapingReload && reSubmit(form);
          setIsScrapingReload(false);
        }
      });
  };

  useEffect(() => {
    if (!isEmpty(financeScrapings)) {
      getHistories(financeScrapings[0]);
    }
  }, [financeScrapings]);


  useEffect(() => {
    setFields([
      { title: "작성일자", key: "writeDate", type: 'date', className: 'nowrap', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "전송일자", key: "issueDate", type: 'date', className: 'nowrap', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      {
        title: "상호", key: "supCorpName", sort: (key) => handleSort(key), order: (key) => orderKey(key),
        onValue: (value, field, data) => {
          return <p
            onClick={(e) => {
              preventEvent(e);
              data?.client?.companyAccountIdx
                && clientPreview(data.client.companyAccountIdx);
            }
            }
          >{value}</p>;
        }
      },
      { title: "대표자명", key: "supRepName", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      {
        title: "사업자번호",
        key: "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        // title: "대표품목", 
        title: "품목",
        key: "itemName",
        sort: (key) => handleSort(key),
        order: (key) => orderKey(key),
        onValue: (value, field, form) => {
          let itemsLabels = '';
          let items = form.taxInvoiceItems.length > 1
            ? `${form.itemName} 외 ${form.taxInvoiceItems.length - 1}건`
            : `${form.itemName}`;
          if (!isEmpty(form.taxInvoiceItems)) {
            forEach(form.taxInvoiceItems, (item) => {
              // if (item.order === 1) {
              //   items +=
              //     form.taxInvoiceItems.length > 1
              //       ? `${item.itemName} 외 ${form.taxInvoiceItems.length - 1}건`
              //       : `${item.itemName}`;
              // }
              const unit = item.unit || '개';
              itemsLabels += `${item.itemName}: ${transformComma(item.unitCost)}원 x ${item.itemQty}${unit} = ${transformComma(item.itemSupAmt + item.itemTaxAmt)}원 (부가세포함) \n`;
            });
          }

          return <>{items}<ToolTip
            position="bottom"
            tooltiptext={itemsLabels}
          /></>;
        },

      },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma',
        className: 'nowrap',
        sortKey: 'itemSupAmt',
        sort: (key) => handleSort('itemSupAmt'), order: (key) => orderKey('itemSupAmt')
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma',
        className: 'nowrap',
        sortKey: 'itemTaxAmt',
        sort: (key) => handleSort('itemTaxAmt'), order: (key) => orderKey('itemTaxAmt')
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma',
        className: 'nowrap',
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: '',
        key: 'comments',
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          );
        }
      },
      {
        title: '매핑된 거래처',
        key: 'client',
        onValue: (value, field, data) => {
          return (
            !isEmpty(value) &&
            (
              <p className="pt-8 pb-8">
                <span className="vertical-middle">{value.name}</span>
                {permission.level > 1 && !data.isIssuedFromService && (
                  <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => handleRemoveClient(data, value)} />)}
              </p>
            )
          );
        }
      }
    ]);
  }, [sortFields]);

  useEffect(() => {
    if (checkedList.includes('tax_invoice') && checkedList.includes('invoice')) {
      setTaxInvoiceType('all');
    } else if (checkedList.includes('tax_invoice') && !checkedList.includes('invoice')) {
      setTaxInvoiceType('tax_invoice');
    } else if (!checkedList.includes('tax_invoice') && checkedList.includes('invoice')) {
      setTaxInvoiceType('invoice');
    } else if (!checkedList.includes('tax_invoice') && !checkedList.includes('invoice')) {
      setTaxInvoiceType('all');
    }

    setInvoiceRegged(!checkedList.includes('invoice_regged'));

  }, [checkedList]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    reSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    selectedList, setSelectedList,
    setOrderBy
  } = useForm({
    order: [{ writeDate: "desc" }],
    range: {
      writeDate: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date,
    },
    search: {
      supCorpName: ""
    },
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }
  }, [sortFields]);

  useEffect(() => {
    if (!isEmpty(history.location.state)) {
      setCheckList([history.location.state.invoiceType]);
    }
  }, [history]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, [taxInvoiceType, invoiceRegged]);

  useEffect(() => {
    excelDown({ form, taxInvoiceType, invoiceRegged });
  }, [form, taxInvoiceType, invoiceRegged]);

  const submit = (params) => {
    setIsLoading(true);
    let _params = cloneDeep(params);
    _params = {
      ..._params,
      ...invoiceRegged ? {} : { invoiceRegged: false }
    };
    getTaxInvoiceList("purchase", taxInvoiceType, { ...getParams(_params) })
      .then((res) => {
        const { totalCount, invoices, comment } = res.data;
        const transList = invoices.map((invoice) => ({
          ...invoice,
          comments: comment.listByPost.find(c => c.postIdx === invoice.idx) || {}
        }));
        setList(transList);
        setTotal(totalCount);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filters = [
    {
      title: '조회기간 (작성일자)',
      type: 'customdatepicker',
      key: "range.writeDate"
    },
    {
      title: '상호명',
      key: "search.supCorpName"
    },
    {
      title: "선택한 항목만 보기",
      key: "check",
      type: "checkboxes",
      className: "margin-right-16",
      checkedList,
      onChange: (checked, value) => {
        let _selectedCheckboxes = [];
        if (checked) {
          _selectedCheckboxes = [...checkedList, value];
        } else {
          _selectedCheckboxes = remove(checkedList, (v) => v !== value);
        }
        setCheckList(_selectedCheckboxes);
      },
      options: {
        list: [
          { label: '세금계산서', value: 'tax_invoice' },
          { label: '계산서', value: 'invoice' },
          { label: '거래명세서 미등록', value: 'invoice_regged' },
        ],
      },
    },
  ];

  const handleOnRowClick = (data, e) => {
    if (e.target.tagName !== "TR" && e.target.tagName !== "TD") return;
    setRowData(data);
    setDetailOpen(true);
  };

  const handleRemoveClient = (data, value) => {
    systemAlert(`${value.name} 거래처 매핑을 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '삭제',
          onClick: () => {
            deleteMappingTaxInvoiceClient(data.idx).then(() => {
              filterSubmit();
            });
          }
        }
      ]
    });
  };

  const rowBtnConfig = {
    title: '거래처 매핑',
    rowButtons: [
      {
        // 거래처 매핑
        type: "edit",
        className: "mr-4",
        action: (data) => {
          setIsClientMappingOpen(true);
          setClientMappingData(data);
        },
      },
    ],
  };

  const tablebuttons = [
    {
      label: "거래명세서 발급",
      color: "gray-line",
      action: () => {
        setIsInvoiceOpen(true);
      },
      disabled: isEmpty(selectedList),
    },
    {
      label: "매입 계산서 스크래핑",
      disabled: isScraping,
      action: () => {
        systemAlert("수동 스크래핑을 진행하시겠습니까?", {
          buttons: [
            {
              label: "취소",
              color: "text"
            },
            {
              label: "확인",
              onClick: () => {
                const promiseList = [];
                const codeList = ["Z3004", "Z3002"];
                codeList.forEach(svcCd => {
                  promiseList.push(scrapingFinanaces(financeScrapings[0].idx, {
                    svcCd,
                    sdate: dateToFormat(new Date(), "YYYYMMDD"),
                    edate: dateToFormat(new Date(), "YYYYMMDD")
                  }));
                });
                viewLoading(true);
                Promise.all(promiseList)
                  .then(() => {
                    setReload(true);
                    setIsScraping(true);
                    systemAlert(
                      <>
                        <p>스크래핑 요청에 성공하였습니다.</p>
                        <p>스크래핑이 완료될 때까지 일정시간이 소요됩니다.</p>
                        <p className="color-red-100">수집이력 내역 반영까지 일정시간이 소요됩니다.</p>
                        <p> 관리자 -&gt; 금융정보 자동 수집 -&gt; 수집이력에서</p>
                        <p>스크래핑 결과를 확인하실 수 있습니다.</p>
                      </>
                      , {
                        buttons: [
                          {
                            label: "수집이력 확인하기",
                            onClick: () => {
                              history.push("/manager/financial?tab=scraping-history");
                            }
                          },
                          {
                            label: "확인",
                            onClick: () => {
                              getHistories(financeScrapings[0]);
                            }
                          },
                        ]
                      });
                  })
                  .catch(() => { })
                  .finally(() => {
                    viewLoading(false);
                  });
              }
            }
          ]
        });
      },
      isHide: isEmpty(financeScrapings) || isEmpty(scrapingPermission) || 1 >= scrapingPermission.level,
    },
  ];

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };
    setSortFields(newArray);
  };

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField.order;
  };


  return (
    <>
      <Filters
        filters={filters}
        isLoading={isLoading}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />
      <ControlTable
        isControl={permission.level > 1}
        buttons={permission.level > 1 ? tablebuttons : []}
        isLoading={isLoading}
        fields={fields}
        sortField={sortFields.find((field) => !isEmpty(field.order))}
        list={list}
        selectedList={selectedList}
        setSelected={setSelectedList}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        submit={handleSubmit}
        onSelect={handleOnRowClick}
        rowBtn={rowBtnConfig}
      />
      {detailOpen && (
        <TaxInvoiceDetail
          open={detailOpen}
          setOpen={setDetailOpen}
          list={rowData}
          setList={setRowData}
          type="purchase"
          permission={permission}
          submit={reSubmit}
        />
      )}
      {isInvoiceOpen && (
        <TaxInvoiceToTradeInvoice
          open={isInvoiceOpen}
          setOpen={setIsInvoiceOpen}
          list={selectedList}
          setList={setSelectedList}
          submit={reSubmit}
          type="purchase"
        />
      )}
      {isClientMappingOpen && (
        <TaxInvoiceClientMapping
          open={isClientMappingOpen}
          setOpen={setIsClientMappingOpen}
          data={clientMappingData}
          setData={setClientMappingData}
          submit={reSubmit}
          invoiceType="tax-invoice"
        />
      )}
    </>
  );
};

export default TaxInvoicePurchase;
